/**
 *    Implements *basic* LocalStorage functionality:
 *    --------------------------------------------------------------------------
 *    - also adds some customised functions around book and edit progress
 **/

export class LS { 
  
  // @TODO: Add expiry date to all items

  static set(name, value) {
    // console.log('LS, set:', name, value);
    window.localStorage.setItem(name, value);
  }

  static get(name) {
    return window.localStorage.getItem(name);
  }
}


/**
 * Listen for orientation event - but ignore when this is triggered by an input-focus event
 **/

export class EapMediaQueries {
  constructor() {
    var rotateSpec = window.matchMedia("(max-height: 475px) and (orientation: landscape)");
    var incompatSpec = window.matchMedia("(max-height: 250px), screen and (max-width: 280px)");
    incompatSpec.addListener(this.onIncompat.bind(this));
    rotateSpec.addListener(this.onRotate.bind(this));
  }

  onRotate(m) {
    if (m.matches && this.checkInputSelected()) {
      document.body.classList.add('eap-rotate-screen');
    } else {
      document.body.classList.remove('eap-rotate-screen');
    }
  }

  onIncompat(m) {
    if (m.matches) {
      document.body.classList.add('eap-incompatible-screen');
    } else {
      document.body.classList.remove('eap-incompatible-screen');
    }
  }

  checkInputSelected() {
    var activeNode = document.activeElement.nodeName;
    return activeNode.indexOf('INPUT') == -1 && activeNode.indexOf('TEXTAREA') == -1;
  }
}


/**
 * Calc's distance between two lat and long coords:
 **/

export class Distance {
  static compare(latlngA,latlngB) {
    var dist = this.distance(latlngA.lat, latlngA.lng, latlngB.lat, latlngB.lng, "K");
    var distText = this.distanceText(dist);
    return { dist: dist, text: distText };
  }

  static distance(lat1, lon1, lat2, lon2, unit) {
    var theta = lon1 - lon2;
    var dist = Math.sin(this.deg2rad(lat1)) 
    * Math.sin(this.deg2rad(lat2)) 
    + Math.cos(this.deg2rad(lat1)) 
    * Math.cos(this.deg2rad(lat2)) 
    * Math.cos(this.deg2rad(theta));
    dist = Math.acos(dist);
    dist = this.rad2deg(dist);
    dist = dist * 60 * 1.1515;
    if (unit == "K") dist = dist * 1.609344;
    else if (unit == "N") dist = dist * 0.8684;
    return dist;
  }

  static distanceText(distance) { 
    var distTxt = "";
    if(distance < 1) {
      var m = distance.toFixed(2);
      distTxt = m.substring(m.indexOf(".") + 1) + "0m"; 
    } else
        distTxt = distance.toFixed(2) + "km"; 
    return distTxt;
  };

  static deg2rad(deg) { return (deg * Math.PI / 180.0); };
  static rad2deg(rad) { return (rad * 180 / Math.PI); };
}

// @TODO: probably dont need this level of error-protection / functionality
// should simplify...
export class Color {
  static shadeBlendConvert(p, from, to) {
    if(typeof(p)!="number"||p<-1||p>1||typeof(from)!="string"||(from[0]!='r'&&from[0]!='#')||(typeof(to)!="string"&&typeof(to)!="undefined"))return null; //ErrorCheck
    if(!this.sbcRip)this.sbcRip=(d)=>{
      let l=d.length,RGB=new Object();
      if(l>9){
        d=d.split(",");
        if(d.length<3||d.length>4)return null;//ErrorCheck
        RGB[0]=i(d[0].slice(4)),RGB[1]=i(d[1]),RGB[2]=i(d[2]),RGB[3]=d[3]?parseFloat(d[3]):-1;
      }else{
        if(l==8||l==6||l<4)return null; //ErrorCheck
        if(l<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(l>4?d[4]+""+d[4]:""); //3 digit
        d=i(d.slice(1),16),RGB[0]=d>>16&255,RGB[1]=d>>8&255,RGB[2]=d&255,RGB[3]=l==9||l==5?r(((d>>24&255)/255)*10000)/10000:-1;
      }
      return RGB;}
    var i=parseInt,r=Math.round,h=from.length>9,h=typeof(to)=="string"?to.length>9?true:to=="c"?!h:false:h,b=p<0,p=b?p*-1:p,to=to&&to!="c"?to:b?"#000000":"#FFFFFF",f=this.sbcRip(from),t=this.sbcRip(to);
    if(!f||!t)return null; //ErrorCheck
    if(h)return "rgb("+r((t[0]-f[0])*p+f[0])+","+r((t[1]-f[1])*p+f[1])+","+r((t[2]-f[2])*p+f[2])+(f[3]<0&&t[3]<0?")":","+(f[3]>-1&&t[3]>-1?r(((t[3]-f[3])*p+f[3])*10000)/10000:t[3]<0?f[3]:t[3])+")");
    else return "#"+(0x100000000+(f[3]>-1&&t[3]>-1?r(((t[3]-f[3])*p+f[3])*255):t[3]>-1?r(t[3]*255):f[3]>-1?r(f[3]*255):255)*0x1000000+r((t[0]-f[0])*p+f[0])*0x10000+r((t[1]-f[1])*p+f[1])*0x100+r((t[2]-f[2])*p+f[2])).toString(16).slice(f[3]>-1||t[3]>-1?1:3);
  }
}

export function GetSimpleRect(el) {
  let rect = el.getBoundingClientRect();
  return {
    top: rect.top,
    left: rect.left,
    width: rect.width,
    height: rect.height
  }
}


export function PromiseState(p) {
  const t = {};
  return Promise.race([p, t])
    .then(v => (v === t) 
      ? "pending" 
      : "fulfilled", () => "rejected");
}


export function SendGAPageView({title='', path='/'}) {
  gtag('config', 'UA-70164706-7', {
    'page_title': title,
    'page_path': path
  });
}
































// WEBPACK FOOTER //
// ./app/frontend/utils-and-data/utils.js